import { FC } from 'react';
import { useTenant } from '../../contexts/TenantContext';
import { UserName } from '../atomic/text';
import React from 'react';
import { SelectField, SelectFieldOption } from '../atomic/forms';

export type UserSelectorProp = {
    onUserChange: any;
};
export const UserSelector: FC<UserSelectorProp> = ({ onUserChange }) => {
    const { tenantUsers } = useTenant();
    const [userId, setUserId] = React.useState<string>('');

    const usersOptions: SelectFieldOption[] = tenantUsers
        .filter((user) => {
            return user.userStatus === 'CONFIRMED';
        })
        .map((user) => {
            return { text: <UserName user={user} />, value: user.userId };
        });
    usersOptions.unshift({ text: '', value: '' });
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <label>ユーザー選択</label>
            <SelectField
                label=""
                value={userId}
                _onChange={(e) => {
                    onUserChange(e);
                    setUserId(e);
                }}
                options={usersOptions}
            />
        </div>
    );
};
